<template>
  <mu-container>
    <mu-paper :z-depth="1" class="w-100 p-20">
      <mu-row>
        <h1>Twój zysk</h1>
      </mu-row>
      <mu-row>
        <mu-col offset="8" span="1">
          <mu-select
            placeholder="Wybierz miesiąc..."
            v-model="month"
            full-width
          >
            <mu-option
              v-for="i in 12"
              :key="i"
              :label="`${i}`"
              :value="i"
            ></mu-option>
          </mu-select>
        </mu-col>
        <mu-col span="1">
          <mu-select placeholder="Wybierz rok..." v-model="year" full-width>
            <mu-option
              v-for="year in years"
              :key="year"
              :label="`${year}`"
              :value="year"
            ></mu-option>
          </mu-select>
        </mu-col>
        <mu-col span="1">
          <mu-button color="primary" @click="getEarningsWithData"
            >Zatwierdź!</mu-button
          >
        </mu-col>
      </mu-row>
      <mu-row>
        <h2>Informacje rozliczeniowe</h2>
      </mu-row>
      <p>
        Liczba zrealizowanych zamówień:
        <strong>{{ earnings.dataChosenMonthYear.count }}</strong>
      </p>
      <p>
        Twój zysk:
        <strong>
          {{
            Number(
              earnings.dataChosenMonthYear.earningsPostpay +
                earnings.dataChosenMonthYear.earningsPrepay
            ).toFixed(2)
          }}
          zł
        </strong>
      </p>
      <!--
      <mu-divider></mu-divider>
      <p>
        <span>
          Poniżej znajdują się informacje rozliczeniowe za wybrany miesiąc z podziałem na zamówienia za pobraniem
          oraz przedpłata. W zależności od wybranej formy płatności pieniądza wpływają do nas (pobranie) lub
          bezpośrednio do Ciebie (przedpłata). Na początku kolejnego miesiąca wystawiamy lub prosimy o wystawienie
          faktury w zależności od tego jakich form przedpłaty było więcej.
        </span>
      </p>
      <mu-divider></mu-divider>
      <h3>
        Zysk z zamówień za pobraniem:
        <span style="color: #2e7d32;">
          {{earnings.dataChosenMonthYear.earningsPostpay}} zł
        </span>
      </h3>
      <h3>
        Zysk z zamówień przedpłata:
        <span style="color: #2e7d32;">
          {{earnings.dataChosenMonthYear.earningsPrepay}} zł
        </span>
      </h3>
      <p v-if="earnings.dataChosenMonthYear.costsPostpay > earnings.dataChosenMonthYear.costsPrepay">
        Prosimy o wystawienie faktury na koniec miesiąca w wysokości:
        {{Number(earnings.dataChosenMonthYear.costsPostpay-earnings.dataChosenMonthYear.costsPrepay).toFixed(2)}}
        zł
      </p>
      <p v-if="earnings.dataChosenMonthYear.costsPrepay > earnings.dataChosenMonthYear.costsPostpay">
        Na koniec miesiąca wystawimy fakturę do opłacenia w wysokości:
        {{Number(earnings.dataChosenMonthYear.costsPrepay-earnings.dataChosenMonthYear.costsPostpay).toFixed(2)}}
        zł
      </p>
      <mu-divider></mu-divider> -->
      <!-- <apexchart width="100%" type="line" :options="chartOptions" :series="series"></apexchart> -->
    </mu-paper>
  </mu-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "EarningsPage",
  data() {
    const curDate = new Date();
    return {
      month: curDate.getMonth() + 1,
      year: curDate.getFullYear(),
      years: Array.from(
        { length: curDate.getFullYear() - 2017 },
        (v, k) => k + 2018
      )
    };
  },
  computed: {
    ...mapState("order", ["earnings"]),
    chartOptions() {
      return {
        chart: {
          id: "earnings-chart",
          shadow: {
            enabled: false,
            color: "#bbb",
            top: 3,
            left: 2,
            blur: 3,
            opacity: 1
          }
        },
        stroke: {
          width: 7,
          curve: "smooth"
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            gradientToColors: ["#FDD835"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100]
          }
        },
        markers: {
          size: 4,
          opacity: 0.9,
          colors: ["#FFA41B"],
          strokeColor: "#fff",
          strokeWidth: 2,

          hover: {
            size: 7
          }
        },
        xaxis: {
          categories: this.earnings.dataLastMonths.keys
        }
      };
    },
    series() {
      return [
        {
          name: "Zarobki",
          data: this.earnings.dataLastMonths.values
        }
      ];
    }
  },
  methods: {
    ...mapActions("order", ["getEarnings"]),
    getEarningsWithData() {
      this.getEarnings({
        month: this.month,
        year: this.year
      });
    }
  },
  mounted() {
    this.getEarningsWithData();
  }
};
</script>

<style scoped>
h1 {
  margin: 0;
}
</style>
